import Segment from './segment';
import SegmentTitle from './segment-title';

export { Segment, SegmentTitle };

export default Segment;
